export default function R_Multiple_Variables() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_Multiple_Variables Component</h1>
      <p>This is the R_Multiple_Variables tutorial section.</p>
    </div>
  );
}
